import { throwError } from 'rxjs';

export class ServiceBaseService {
  constructor() {}

  public _errorHandler(error: Response) {
    console.log(error);
    return throwError(() => error || 'Internal server error');
  }
}
